

export class Tooltip {
    overlayClass = '.b-omnichinality__overlay';
    ACTIVE_CLASS = 'active'
    tooltipClose = '.js-tooltip-close';
    tooltipCard = '.b-omnichinality__tooltip';

    onClick = (e) => {

        this.closeAll();

        const el = $(e.currentTarget);
        this.position(e);
        this.overlay.fadeIn();
        $(`#${this.target}`).addClass(this.ACTIVE_CLASS);
        $(`#${this.target}`).fadeIn();

        if (window.matchMedia('(min-width: 1200px)').matches){
            $(window).on('scroll', this.closeOnScroll);
        }else {
            $(window).off('scroll', this.closeOnScroll);
        }

        $(document).on('keyup', this.escPress);
    }

    escPress = (e) => {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
               this.closeAll();
        }
    }

    position = (el) => {
        const tWidth = this.tooltipBody.width();
        const tHeight = this.tooltipBody.height();
        // this.tooltipBody.css({top: `${el.position().top + tHeight}px`, left: `${el.position().left + tWidth}`})
    }

    closeAll = () => {
        $('.js-tooltip-close').parent().removeClass(this.ACTIVE_CLASS);
        $('.js-tooltip-close').parent().fadeOut();
        $(document).off('keyup', this.escPress);
    }

    closeOnScroll = (e) => {
        this.closeAll();
        this.closeOverlay();
    }

    closeTooltip = (e) => {
        const el = $(e.currentTarget);

        const tooltipEl = el.parent();

        tooltipEl.removeClass(this.ACTIVE_CLASS);
        tooltipEl.fadeOut();
        this.closeOverlay();
        $(window).off('scroll', this.closeOnScroll);
    }

    onClickOverlay = (e) => {
        const el = $(e.currentTarget);
        this.tooltipBody.removeClass(this.ACTIVE_CLASS);
        this.closeOverlay();
    }

    closeOverlay = () => {
        this.overlay.fadeOut();
    }

    constructor(node){
        this.node = $(node);
        this.target = this.node.data('tooltip-id');
        this.closeEl = $(this.tooltipClose);
        this.isOpen = false;
        this.overlay = $(this.overlayClass);
        this.tooltipBody = $(`#${this.target}`);

        this.node.on('click', this.onClick);
        this.closeEl.on('click', this.closeTooltip);
        this.overlay.on('click', this.onClickOverlay);
    }
}



// WEBPACK FOOTER //
// ./app/scripts/shared/Tooltip.js